import React, { forwardRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

import {
  changeAppointmentData,
  changeErrorObject,
  changeTime,
  getPortalAppAvailablity,
} from "../../../StateManagement/Reducers/AppointmentsState";

import {
  DateInput,
  DateChangeButton,
  SlideContainer,
  Slide,
  TimePills,
  TimeSelectorDiv,
} from "./Styles";
import { Button, Div, NormalImage } from "../../StyledComponents";

import Loading from "../../StyledComponents/Loading";
import leftIcon from "../../../Assets/images/left_arrow_icon.png";
import rightIcon from "../../../Assets/images/right_arrow_icon.png";

const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <DateInput onClick={onClick} ref={ref} onChange={onChange}>
    {value}
  </DateInput>
));

const TimeDateSelector = ({ isWaitListChecked, setIsWaitListChecked }) => {
  // ------------------------------ State and Variables Start--------------------------------------------------- //
  const [mrng, setMrng] = useState(true);
  const [aftnun, setAftnun] = useState(false);
  const [evng, setEvng] = useState(false);
  const dispatch = useDispatch();
  const [isAllSlotsAreBooked, setIsAllSlotsAreBooked] = useState(false);
  const appointmentData = useSelector(
    (state) => state.Appointments.appointmentData
  );
  const sliderObject = useSelector((state) => state.Appointments.sliderObject);
  const loader = useSelector((state) => state.Appointments.loadAvailablity);

  const PortalAppAvailability = useSelector(
    (state) => state.Appointments.portalAppAvailablity
  );
  const Availablity = useSelector(
    (state) => state.Appointments.providerAvailablity
  );
  const checkTimeAvailablity = (timeStr, isManuallyDisabled) => {
    const slotDateTime = moment(
      `${appointmentData["aptdate"]} ${timeStr}`,
      "YYYY-MM-DD hh:mm A"
    );

    const now = moment();
    const startDate = moment(
      PortalAppAvailability["StartDate"],
      "YYYY-MM-DD hh:mm A"
    );
    const endDate = moment(
      PortalAppAvailability["EndDate"],
      "YYYY-MM-DD hh:mm A"
    );

    return (
      isManuallyDisabled ||
      slotDateTime.isBefore(now) ||
      slotDateTime.isBefore(startDate) ||
      slotDateTime.isAfter(endDate)
    );
  };

  const clickMorning = () => {
    setMrng(true);
    setAftnun(false);
    setEvng(false);
  };

  const clickAfterNun = () => {
    setAftnun(true);
    setMrng(false);
    setEvng(false);
  };

  const clickEvening = () => {
    setEvng(true);
    setMrng(false);
    setAftnun(false);
  };

  useEffect(() => {
    const now = new Date();

    const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const systemOffset = new Date().getTimezoneOffset();

    const pad = (n) => n.toString().padStart(2, "0");
    const localTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
      now.getDate()
    )} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
      now.getSeconds()
    )}`;

    dispatch(
      getPortalAppAvailablity({
        systemTimeZone: systemTimeZone,
        systemOffset: systemOffset,
        formattedNow: localTime,
      })
    );
  }, []);
  useEffect(() => {
    let allDisabled = true; // assume all are disabled by default

    ["morning", "afternoon", "evening"].forEach((period) => {
      const slots = Availablity[period];
      if (slots && slots.length > 0) {
        const periodAllDisabled = slots.every((x) =>
          checkTimeAvailablity(x["time"], x["disable"])
        );
        if (!periodAllDisabled) {
          allDisabled = false; // if any period has available slot
        }
      }
    });

    setIsAllSlotsAreBooked(allDisabled);
  }, [Availablity, appointmentData, PortalAppAvailability]);

  // ------------------------------ State and Variables End--------------------------------------------------- //

  return (
    <>
      <TimeSelectorDiv>
        <DateChangeButton
          leftArrow
          onClick={() => {
            const newDate = moment(
              appointmentData["aptdate"],
              "YYYY-MM-DD"
            ).subtract(1, "days");

            const startMoment = moment(
              PortalAppAvailability["StartDate"]
            ).startOf("day");
            const today = moment().startOf("day");

            // Ensure newDate is not before startMoment AND not before today
            if (newDate.isSameOrAfter(today)) {
              const formatted = newDate.format("YYYY-MM-DD");
              dispatch(
                changeAppointmentData({ name: "aptdate", value: formatted })
              );
            }
          }}
        >
          <NormalImage
            loading="lazy"
            src={leftIcon}
            height="55.55%"
            width="55.55%"
            border="none"
          />
        </DateChangeButton>
        <DatePicker
          selected={moment(appointmentData["aptdate"]).toDate()} // ✅ Date object
          dateFormat="MMM dd, yyyy"
          minDate={new Date(PortalAppAvailability["StartDate"])}
          maxDate={new Date(PortalAppAvailability["EndDate"])}
          onChange={(date) => {
            const a = moment(date).format("YYYY-MM-DD");
            dispatch(changeAppointmentData({ name: "aptdate", value: a }));
          }}
          customInput={<CustomInput />}
        />

        <DateChangeButton
          rightArrow
          onClick={() => {
            let result = moment(appointmentData["aptdate"]).add(1, "d");
            let a = result.format("YYYY-MM-DD");
            if (a <= PortalAppAvailability["EndDate"]) {
              dispatch(changeAppointmentData({ name: "aptdate", value: a }));
            }
          }}
        >
          <NormalImage
            loading="lazy"
            src={rightIcon}
            height="55.55%"
            width="55.55%"
          />
        </DateChangeButton>
      </TimeSelectorDiv>

      {!loader && Object.keys(Availablity).length > 0 ? (
        <>
          <Div width="100%" height="31%" position="relative" padding="8px 0px">
            <Div
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap="10px"
            >
              <Button
                height="30px"
                width="75px"
                background={mrng ? "#2C7BE5" : "#fff"}
                color={mrng ? "#fff" : "#b7b7b7"}
                border="1px solid #d8e0f0"
                borderRadius="4px"
                onClick={clickMorning}
              >
                Morning
              </Button>
              <Button
                height="30px"
                width="75px"
                background={aftnun ? "#2C7BE5" : "#fff"}
                color={aftnun ? "#fff" : "#b7b7b7"}
                border="1px solid #d8e0f0"
                borderRadius="4px"
                onClick={clickAfterNun}
              >
                Afternoon
              </Button>
              <Button
                height="30px"
                width="75px"
                background={evng ? "#2C7BE5" : "#fff"}
                color={evng ? "#fff" : "#b7b7b7"}
                border="1px solid #d8e0f0"
                borderRadius="4px"
                onClick={clickEvening}
              >
                Evening
              </Button>
            </Div>
            <SlideContainer>
              <Div
                width="100%"
                // height="calc(100% - 20px)"
                flexCenterVertical
                margin="8px 0px 0px"
                position="relative"
              >
                {mrng && (
                  <Slide
                    width="150%"
                    slideLeft={sliderObject["morning"]}
                    absoluteLeft="-50%"
                  >
                    {Availablity["morning"]?.map((x, i) => (
                      <TimePills
                        width="14%"
                        Selected={
                          appointmentData["apttime"]?.toLowerCase() ===
                          x["time"]?.toLowerCase()
                        }
                        key={i}
                        value={x["time"]}
                        onClick={(e) => {
                          if (
                            appointmentData["provider"] === "" ||
                            appointmentData["office"] === ""
                          ) {
                            dispatch(
                              changeErrorObject({
                                name: "noProvider",
                                value: true,
                              })
                            );
                          } else {
                            dispatch(changeTime(e.target.value));
                            dispatch(
                              changeErrorObject({
                                name: "noTime",
                                value: false,
                              })
                            );
                          }
                        }}
                        disabled={checkTimeAvailablity(x["time"], x["disable"])}
                        id={`crt_appt-btn_tim${i}`}
                      >
                        {x["time"]}
                      </TimePills>
                    ))}
                  </Slide>
                )}

                {aftnun && (
                  <Slide
                    width="150%"
                    slideLeft={sliderObject["morning"]}
                    absoluteLeft="-50%"
                  >
                    {Availablity["afternoon"]?.map((x, i) => (
                      <TimePills
                        width="14%"
                        Selected={
                          appointmentData["apttime"]?.toLowerCase() ===
                          x["time"]?.toLowerCase()
                        }
                        key={i}
                        value={x["time"]}
                        onClick={(e) => {
                          if (
                            appointmentData["provider"] === "" ||
                            appointmentData["office"] === ""
                          ) {
                            dispatch(
                              changeErrorObject({
                                name: "noProvider",
                                value: true,
                              })
                            );
                          } else {
                            dispatch(changeTime(e.target.value));
                            dispatch(
                              changeErrorObject({
                                name: "noTime",
                                value: false,
                              })
                            );
                          }
                        }}
                        disabled={checkTimeAvailablity(x["time"], x["disable"])}
                        id={`crt_appt-btn_tim${i}`}
                      >
                        {x["time"]}
                      </TimePills>
                    ))}
                  </Slide>
                )}

                {evng && (
                  <Slide
                    width="150%"
                    slideLeft={sliderObject["evening"]}
                    absoluteLeft="-50%"
                  >
                    {Availablity["evening"]?.map((x, i) => (
                      <TimePills
                        width="14%"
                        Selected={
                          appointmentData["apttime"]?.toLowerCase() ===
                          x["time"]?.toLowerCase()
                        }
                        key={i}
                        value={x["time"]}
                        onClick={(e) => {
                          if (
                            appointmentData["provider"] === "" ||
                            appointmentData["office"] === ""
                          ) {
                            dispatch(
                              changeErrorObject({
                                name: "noProvider",
                                value: true,
                              })
                            );
                          } else {
                            dispatch(changeTime(e.target.value));
                            dispatch(
                              changeErrorObject({
                                name: "noTime",
                                value: false,
                              })
                            );
                          }
                        }}
                        disabled={checkTimeAvailablity(x["time"], x["disable"])}
                        id={`crt_appt-btn_tim${i}`}
                      >
                        {x["time"]}
                      </TimePills>
                    ))}
                  </Slide>
                )}
              </Div>
            </SlideContainer>
            {isAllSlotsAreBooked && (
              <div style={{ marginTop: "5px" }}>
                <div>
                  <span className="pe-2">
                    <input
                      type="checkbox"
                      checked={isWaitListChecked}
                      onChange={() => {
                        setIsWaitListChecked(true);
                      }}
                    />
                  </span>
                  <span style={{ marginLeft: "5px" }}>
                    {" "}
                    Add to Waitlist if there’s no available slots
                  </span>
                </div>
              </div>
            )}
          </Div>
        </>
      ) : (
        <Loading position="absolute" height="100%" />
      )}
    </>
  );
};

export default TimeDateSelector;
